import { Injectable } from "@angular/core";

interface ProcessIndicatorData {
  text: string;
  completionPercentage?: number;
}

@Injectable({
  providedIn: "root",
})
export class ProcessIndicatorService {
  public data: ProcessIndicatorData;

  showProcessIndicator(data: ProcessIndicatorData) {
    this.data = data;
  }

  hideProcessIndicator() {
    this.data = null;
  }
}
